import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import BottomTabBar from "../BottomTabBar/BottomTabBar";
import ethTabIcon from "../../assets/media/icons/ETH-Logo-Medium.png";

const TABS = [
  { id: "pnl", label: "Your PNL", icon: ethTabIcon },
  { id: "leaderboard", label: "Leaderboard", icon: "/assets/bear-bull-game/leaderboard.svg" },
];

/**
 * Bottom navigation: landing / Your PNL (`/`) vs NFT leaderboard (`/?tab=leaderboard`).
 */
const FortuneTabBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");

  const activeTab =
    location.pathname === "/" && tabFromUrl === "leaderboard" ? "leaderboard" : "pnl";

  const handleTabClick = (tabId) => {
    if (tabId === "pnl") {
      if (tabFromUrl === "leaderboard") {
        navigate("/");
      }
      return;
    }
    if (tabId === "leaderboard") {
      navigate("/?tab=leaderboard");
    }
  };

  return (
    <BottomTabBar tabs={TABS} activeTab={activeTab} onTabClick={handleTabClick} />
  );
};

export default FortuneTabBar;
export { TABS };
